module.exports = __webpack_public_path__ + "static/img/4.3f0b4ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/4.png
// module id = rAW1
// module chunks = 0